import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export default function FooterHome() {
  return (
    <footer style={styles.footer}>
      <Typography variant="body2" style={{ color: '#E5E6F0' }} align="center">
        {'Copyright © '}
        <Link color="inherit" href="http://kintelligence.com.br" target="_blank">
          K-Intelligence
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </footer>
  );
}

let styles = {
  footer: {
    backgroundColor: '#343434 ',
    height: 60,
    paddingTop: 40,
    paddingBotton: 40,
    marginTop: 90,
  }
};
